import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { togglePopUp } from "../cartPopUp/cartPopUpSlice";
import { IPaymentResponse } from "@/components/Checkout/CartSummary/CartSummary";

interface ICartData {
  products: ICartProduct[];
  totalItems: number;
  totalAmount: number;
  hasPlan: boolean;
  hasDevice: boolean;
}

export const cart = createSlice({
  name: "cart",
  initialState: {
    products: [] as ICartProduct[],
    sessionId: "",
    cartId: "",
    totalItems: 0,
    totalAmount: 0,
    hasPlan: false,
    hasDevice: false,
    paymentResponse: null as IPaymentResponse | null,
    checkboxValue: true,
  },
  reducers: {
    setCartData: (state, { payload }: PayloadAction<ICartData>) => {
      state.products = payload.products;
      state.totalItems = payload.totalItems;
      state.totalAmount = payload.totalAmount;
      state.hasPlan = payload.hasPlan;
      state.hasDevice = payload.hasDevice;
      state.paymentResponse = null;
      if (payload.products.length === 0) {
        togglePopUp();
      }
    },
    updateProductQuantity: (
      state,
      { payload }: PayloadAction<ICartProduct>
    ) => {
      const index = state.products.findIndex(
        ({ idProduct }) => idProduct === payload.idProduct
      );
      if (index !== -1) {
        const prevQuantity = state.products[index].quantity;
        if (payload.quantity === 0) {
          state.totalItems -= prevQuantity;
          state.totalAmount -= prevQuantity * (state.products[index].realPrice || 0);
          state.products = state.products.filter((_, i) => i !== index);
          if (state.products.length === 0) {
            togglePopUp();
          }
        } else {
          state.products[index].quantity = payload.quantity;
          state.totalItems += payload.quantity - prevQuantity;
          state.totalAmount +=
            (payload.quantity - prevQuantity) * (state.products[index].realPrice || 0);
        }
      }
    },

    removeProductFromCart: (state, { payload }: PayloadAction<number>) => {
      const product = state.products.find(
        ({ idProduct }) => idProduct === payload
      );
      if (product) {
        state.totalItems -= product.quantity;
        state.totalAmount -= product.quantity * product.price;
      }
      state.products = state.products.filter(
        (item) => item.idProduct !== payload
      );
      if (state.products.length === 0) {
        togglePopUp();
      }
    },

    setCartId: (state, { payload }: PayloadAction<string>) => {
      state.cartId = payload;
    },
    setSessionId: (state, { payload }: PayloadAction<string>) => {
      state.sessionId = payload;
      localStorage.setItem("sessionId", payload);
    },
    setPaymentResponse: (state, { payload }: PayloadAction<any>) => {
      state.paymentResponse = payload;
    },
    addProductToCart: (state, { payload }: PayloadAction<ICartProduct>) => {
      const index = state.products.findIndex(
        ({ idProduct }) => idProduct === payload.idProduct
      );
      if (index !== -1) {
        state.products[index].quantity += payload.quantity;
      } else {
        state.products.push(payload);
      }
      state.totalItems += payload.quantity;
      state.totalAmount += payload.price * payload.quantity;
    },
    setCheckboxValue: (state, { payload }: PayloadAction<boolean>) => {
      state.checkboxValue = payload;
    },
    clearCart: (state) => {
      state.products = [];
      state.totalItems = 0;
      state.totalAmount = 0;
      state.hasPlan = false;
      state.hasDevice = false;
      state.paymentResponse = null;
      state.cartId = "";
      state.sessionId = "";
      localStorage.removeItem("sessionId");
      togglePopUp();
    },
  },
});

export const {
  setCartData,
  updateProductQuantity,
  addProductToCart,
  setPaymentResponse,
  removeProductFromCart,
  setCartId,
  setSessionId,
  setCheckboxValue,
  clearCart,
} = cart.actions;
export const cartReducer = cart.reducer;
